import { Rol } from './../../models/rol.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { Observable } from 'rxjs/Observable';
import { DowloadFile } from '@app/forms/shared/attached-document/shared/attached-document.data.service';

@Injectable()
export class DynamicViewDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) { }

  /**
   * Consulta la informacion de la vista renderizada
   * ya sea ejecutando filtro por tramite
   *
   * @param {number} idView
   * @param {number} idTramite
   * @returns {Observable<any[]>}
   * @memberof DynamicViewDataService
   */
  getDataTables(idView: number, idTramite?: number): Observable<any[]> {
    return new Observable(obs => {
      const formData = {};
      if (idTramite) {
        formData['tramite_id'] = idTramite;
      }
      this.http.put<any[]>(this.api.get('dynamicView', [idView]), formData).subscribe(
        data => {
          obs.next(data);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Consulta un rol(grupo).
   *
   * @param {number} idRol
   * @returns {Promise<Rol>}
   * @memberof DynamicViewDataService
   */
  getRole(idRol: number, offset:number=0, limit:number=50, filters:any=null): Promise<Rol> {
    //return this.http.get<Rol>(this.api.get('roles', [idRol]));
    const data = {
      rol: idRol,
      offset: offset,
      limit: limit,
      filters: filters
    };
    return new Promise((resolve, reject) => {
      this.http.post<Rol>(this.api.get('rolUser'), data).subscribe(
          masterTable => {
            resolve(masterTable);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  /**
   * Iniciar los procesos de destino asociados a los procesos de origen
   * asignando el usuario actual
   *
   * @param {number} idView
   * @param {number[]} process_id
   * @returns {Observable<boolean>}
   * @memberof DynamicViewDataService
   */
  initProcess(idView: number, process_id: number[]): Observable<boolean> {
    return new Observable(obs => {
      const formData = {
        metodo: 'iniciar_tramite',
        vista_id: idView,
        parametros: {
          tramites: process_id
        }
      };
      this.http.post<any>(this.api.get('instanceViewMethods'), formData).subscribe(
        _data => {
          this.toastr.success('Tramites iniciados correctamente', 'Operación exitosa');
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Iniciar los procesos de destino asociados a los procesos de origen
   * asignando usuarios responsables
   *
   * @param {number} idView
   * @param {number[]} process_id
   * @param {number[]} responsible
   * @returns {Observable<boolean>}
   * @memberof DynamicViewDataService
   */
  initProcessAsignament(idView: number, process_id: number[], responsible: number[]): Observable<boolean> {
    return new Observable(obs => {
      const formData = {
        metodo: 'iniciar_asignando_responsables',
        vista_id: idView,
        parametros: {
          tramites: process_id,
          responsables: responsible
        }
      };
      this.http.post<any>(this.api.get('instanceViewMethods'), formData).subscribe(
        _data => {
          this.toastr.success('Tramites iniciados correctamente', 'Operación exitosa');
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Generar reporte de la tabla de la vista
   *
   * @param {number} idView
   * @param {any[]} dataReport
   * @returns {Observable<DowloadFile>}
   * @memberof DynamicViewDataService
   */
  generateReport(idView: number, dataReport: any[]): Observable<DowloadFile> {
    return new Observable(obs => {
      const formData = {
        metodo: 'generar_reporte',
        vista_id: idView,
        parametros: {
          datos_reporte: dataReport
        }
      };
      this.http.post<DowloadFile>(this.api.get('instanceViewMethods'), formData).subscribe(
        data => {
          obs.next(data);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dynamic-view/shared/dynamic-view.data.service.ts